import { DiscountTermType } from "@/lib/gql/__generated__/graphql";

import type { FormOptionType } from "@/components/ui/form/_types/type";

export const StaticTermTypeOptions = [
	{
		id: DiscountTermType.PerDate,
		label: "1日ごとに",
		value: DiscountTermType.PerDate,
	},
	{
		id: DiscountTermType.PerReservation,
		label: "予約を通して",
		value: DiscountTermType.PerReservation,
	},
] satisfies Array<FormOptionType>;
